import React from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import InputDatetime from "../../../../../../components/input/input-datetime.jsx";
import {FaHouse, FaTaxi} from "react-icons/fa6";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import {SCHEDULE_TYPE_OPTIONS} from "../../utils/schedule-utils.js";
import {startOfToday} from "date-fns";

const TYPE_EXTRAS = {
    VISIT: {Icon: FaHouse, text: "Atendimento presencial no endereço do protegido."},
    PATROL: {Icon: FaTaxi, text: "Patrulhamento nas imediações do endereço do protegido."},
};

const TYPE_OPTIONS = SCHEDULE_TYPE_OPTIONS.map(option => ({...option, ...TYPE_EXTRAS[option.value]}));

const ScheduleDefinitionStep = ({data, setData}) => {
    const handleField = (field, value) => setData(prev => ({...prev, [field]: value ?? ""}));

    return (
        <article className={"space-y-2"}>
            <Card>
                <Card.Header>
                    <Card.Title>Selecionar o tipo de agendamento</Card.Title>
                </Card.Header>

                <Card.Body className={"flex gap-3 w-4/5 justify-self-center"}>
                    {
                        TYPE_OPTIONS.map(({value, label, Icon, text}) => {
                            const selected = data.type === value;

                            return (
                                <button
                                    key={value}
                                    type="button"
                                    onClick={() => handleField("type", value)}
                                    className={[
                                        "flex items-center gap-3 w-1/2 h-24 rounded-lg border-2 cursor-pointer transition-colors px-4.5",
                                        selected
                                            ? "border-[#063A6C] bg-blue-50 text-[#063A6C]"
                                            : "border-gray-200 text-gray-400 hover:border-[#063A6C] hover:text-[#063A6C]"
                                    ].join(" ")}
                                >
                                    <Icon size={40}/>
                                    <section>
                                        <h3 className={"text-left! m-0!"}>{label}</h3>
                                        <p className={"text-left!"}>{text}</p>
                                    </section>
                                </button>
                            )
                        })
                    }

                </Card.Body>
            </Card>

            <Card>
                <Card.Header>
                    <Card.Title>Selecionar a data/hora do agendamento</Card.Title>
                </Card.Header>

                <Card.Body className={"space-y-4 w-4/5 justify-self-center"}>
                    <SentryRow className={"grid-cols-3!"}>
                        <InputDatetime
                            id={"date"}
                            label={"Data *"}
                            dateFormat={"L"}
                            returnDateObj={false}
                            restrictions={{before: startOfToday()}}
                            selected={data.date}
                            onChange={(value) => handleField("date", value)}
                        />

                        <InputDatetime
                            id={"startTime"}
                            label={"Horário inicial *"}
                            dateFormat={"LT"}
                            returnDateObj={false}
                            selected={data.startTime}
                            onChange={(value) => handleField("startTime", value)}
                        />

                        <InputDatetime
                            id={"endTime"}
                            label={"Horário final *"}
                            dateFormat={"LT"}
                            returnDateObj={false}
                            selected={data.endTime}
                            onChange={(value) => handleField("endTime", value)}
                        />
                    </SentryRow>
                </Card.Body>
            </Card>
        </article>
    );
};

export default ScheduleDefinitionStep;
